export const ERRORS = {
    onBegin: {
        noTestsToReport: "No tests to report",
        failedToGetCommitSha: "Failed to get current commit SHA.",
        failedToGetAuthor: "Failed to get current author.",
        failedToGetBranch: "Failed to get current branch.",
        failedToGetCommitMessage: "Failed to get current commit message.",
        failedToInitializeRun: "Failed to initialize run in reporter",
        testsWillNotBeReported: "The tests will not be reported to NeetoPlaydash. The run will continue execution.",
        invalidProjectKey: "The provided project key is invalid. \nPlease verify the project key in the configuration or visit https://help.neetoplaydash.com/p/a-aa711560\nto get more details on how to create a new project.",
        invalidApiKey: "The provided API key is invalid. \nPlease verify the API key in the configuration or visit https://help.neetoplaydash.com/p/a-e1c8f8ca\nto get more details on how to generate a new API key.",
        duplicateCiBuildId: "The provided CI build ID  has already been used. \nPlease use a new value to uniquely identify the run or visit https://help.neetoplaydash.com/p/a-e8dd98fa\nto get more details on the environment variables used in popular CI providers for uniquely identifying executions.",
        defaultApiKeyValueUsed: 'Please replace "api-key" with your own API key. \nVisit https://help.neetoplaydash.com/p/a-e1c8f8ca to get more details on how to generate one.',
    },
    preprocess: {
        failedToDistributeTests: (error) => `NeetoPlaydash could not distribute tests (${error}). Falling back to Playwright's own --shard distribution.`,
        unsupportedPlaywrightVersion: (version) => `Smart orchestration needs Playwright 1.63 or later, but this run uses ${version}. Falling back to Playwright's own --shard distribution.`,
        noTestsForShard: (shard) => `NeetoPlaydash returned no tests for shard ${shard}. Falling back to Playwright's own --shard distribution.`,
    },
    onTestBegin: {
        failedToReportTest: (testTitle, historyId) => `Failed to initialize the attempt for the test "${testTitle}" with history ID ${historyId}`,
    },
    onEnd: { failedToReportRunStatus: "Failed to report run status" },
    onTestEnd: {
        failedToReportTest: (testTitle, historyId) => `Failed to report the final result of the test "${testTitle}" with history ID ${historyId}`,
        attemptAlreadyReported: "Attempt was already reported",
    },
    heartbeat: { stopped: "Run was stopped from NeetoPlaydash" },
    common: { timeoutExceeded: "Timed out waiting for condition." },
    fixtures: {
        attachLightHouseReport: {
            unsupportedFileType: (pathToLightHouseHTMLReport) => `Only HTML reports are supported. Skipping attachment ${pathToLightHouseHTMLReport}.`,
        },
    },
};
//# sourceMappingURL=errors.js.map